
export const USERNAME_ALREADY_EXISTS = 501;
export const NAME_IS_REQUIRED = 502;
export const EMAIL_IS_REQUIRED = 503;
export const EMAIL_ALREADY_EXISTS = 504;
export const INCORRECT_USERNAME_OR_PASSWORD = 505;
export const ACCOUNT_NOT_CONFIRMED = 506;
export const ACCOUNT_SUSPENDED = 507;
export const ACCOUNT_BANNED = 508;
export const ACCOUNT_PASSWORD_NOT_MATCH = 509;
export const ACCOUNT_RESET_EXPIRED = 510;
export const TERMS_OF_SERVICE_REQUIRED = 511;
export const UNEXPECTED_ERROR = 512;
export const INVALID_CODE = 513;
export const CODE_EXPIRED = 514;
export const GOOGLE_EMAIL_NOT_VERIFIED = 515;
export const GOOGLE_INFO_NOT_FOUND = 516;